// Investigation Canvas API
import { apiClient } from './client'

export interface Canvas {
  id: string
  name: string
  description?: string
  case_id: string
  created_at: string
  updated_at: string
  node_count: number
  edge_count: number
}

export interface CreateCanvasRequest {
  name: string
  description?: string
}

export interface CreateHypotheticalNodeRequest {
  labels: string[]
  properties: Record<string, unknown>
}

export interface CreateHypotheticalEdgeRequest {
  source_node_id: string
  target_node_id: string
  relationship_type: string
  properties: Record<string, unknown>
}

export interface CreateStickyNoteRequest {
  text: string
  color: string
}

export const canvasesApi = {
  // List canvases for a case
  list: (caseId: string) => apiClient.get<Canvas[]>(`/cases/${caseId}/canvases`),

  // Get canvas graph
  getGraph: (canvasId: string) =>
    apiClient.get<{ nodes: unknown[]; edges: unknown[] }>(`/canvases/${canvasId}/graph`),

  create: (caseId: string, request: CreateCanvasRequest) =>
    apiClient.post<Canvas>(`/cases/${caseId}/canvases`, request),

  delete: (caseId: string, canvasId: string) =>
    apiClient.delete<void>(`/cases/${caseId}/canvases/${canvasId}`),

  copyNodes: (canvasId: string, nodeIds: string[]) =>
    apiClient.post<void>(`/canvases/${canvasId}/nodes`, { node_ids: nodeIds }),

  createHypotheticalNode: (canvasId: string, request: CreateHypotheticalNodeRequest) =>
    apiClient.post<unknown>(`/canvases/${canvasId}/nodes/hypothetical`, request),

  createHypotheticalEdge: (canvasId: string, request: CreateHypotheticalEdgeRequest) =>
    apiClient.post<unknown>(`/canvases/${canvasId}/edges/hypothetical`, request),

  createStickyNote: (canvasId: string, nodeId: string, request: CreateStickyNoteRequest) =>
    apiClient.post<unknown>(`/canvases/${canvasId}/nodes/${nodeId}/sticky-note`, request),

  deleteEdge: (caseId: string, canvasId: string, edgeId: string) =>
    apiClient.delete<void>(
      `/cases/${caseId}/canvases/${canvasId}/edges/${encodeURIComponent(edgeId)}`
    ),
}
